module.exports = __webpack_public_path__ + "static/img/img-6.17b0e61c.jpg";